import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { modal, reservation, cart, global } from 'actions';
import { Form } from 'react-final-form';
import scrollIntoView from 'scroll-into-view';
import Portal from 'common/components/Portal';
import Field from 'common/components/Form/Field';
import Daypicker from 'common/components/Form/Daypicker';
import dateFormat from 'dateformat';
import { t } from 'translates';
import Icon from 'common/components/Icon';
import Message from 'common/components/Message';
import isMobile from 'common/helpers/isMobile';
import Languages from 'apps/sessions/components/FilterDialog/Languages';
import storage from 'storage';
const pg_type = window.drupalSettings && window.drupalSettings.pg_type || '';

class Reservation extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    sessions: PropTypes.array.isRequired,
    languages: PropTypes.array.isRequired,
    dialog: PropTypes.shape({
      persons: PropTypes.number,
      session_id: PropTypes.string,
      product_id: PropTypes.string,
      sessions: PropTypes.array,
    }).isRequired,
    actions: PropTypes.shape({
      modal: PropTypes.object,
      reservation: PropTypes.object,
      cart: PropTypes.object,
    }).isRequired,
  };

  constructor(props) {
    super(props);

    const { dialog: { date } } = props;
    this.state = {
      selectedDate: date ? this.convertTimezone(new Date(date)) : null,
      openModalMessage: false,
      reservationSuccess: false,
      checkedLanguages: [],
    };
    this.handlePersonsChange = this.handlePersonsChange.bind(this);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleLanguageClick = this.handleLanguageClick.bind(this);
    this.handleSessionClick = this.handleSessionClick.bind(this);
    this.close = this.close.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.productWrapperRef = React.createRef();
  }

  componentWillReceiveProps({ dialog: { persons, date, sessions } }) {
    sessions.map(s => {
      s.date = this.convertTimezone(s.date);
    });
    const state = {};
    if (date && date !== this.props.dialog.date ) {
      state.selectedDate = this.convertTimezone(new Date(date));

      if (sessions.length) {
        const { checkedLanguages: languages } = this.state;
        let filteredSessions = sessions.filter(session => languages.includes(session.language));
        const session = filteredSessions.find(({ available_places }) => available_places >= persons);
        if (session) {
          this.props.actions.reservation.changeSession(session.id);
        }
      }
    }

    if (Object.keys(state).length) {
      this.setState(state);
    }
    if (!this.props.isOpen) {
      this.placesFromUrlFilters = parseInt(Reservation.getParameterByName('places', window.location.href));
    }
  }
  hideError(e) {
    e.preventDefault();
    this.props.actions.modal.hide('gift.error');
  }

  showMessage(message, type) {
    this.props.actions.modal.show('reservation.error', {
      message,
      hideButton: false,
      type,
    });

    const cursusModalTimeout = setTimeout(() => {
      this.props.actions.modal.hide('reservation.error');
      clearTimeout(cursusModalTimeout);
    }, 8000);
  }

  componentDidMount() {
    const { itemListName } = this.productWrapperRef.current.parentNode.dataset;
    this.props.actions.global.setItemListName(itemListName);
  }

  componentDidUpdate(prevProps) {
    const {
      sessions,
      dialog: { session_id },
    } = this.props;
    const { checkedLanguages: languages } = this.state;
    const currentSession = sessions.find(item => item.id === session_id);
    const langArray = sessions.map(item => item.language).filter((item, i, arr) => arr.indexOf(item) === i);

    // if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen && currentSession) {
    if (prevProps.dialog.session_id !== this.props.dialog.session_id && currentSession) {
      const currentLangArr = languages.length ? languages : [currentSession.language];

      this.setState({
        checkedLanguages: currentLangArr
      });
      this.props.actions.reservation.changeLanguage(currentLangArr);
    } else {
      if (prevProps.languages !== this.props.languages) {
        this.setState({
          checkedLanguages: langArray
        });
        this.props.actions.reservation.changeLanguage(langArray);
      }
    }

    if (prevProps.isOpen !== this.props.isOpen && !this.props.isOpen) {
      this.setState({
        checkedLanguages: []
      });
      this.props.actions.reservation.changeLanguage([]);
    }

    if (this.state.openModalMessage) {
      this.setState({
        openModalMessage: false,
      });
    }
  }

  handlePersonsChange(e) {
    e.preventDefault();
    const { dialog: { sessions, session_id } } = this.props;
    const maxSessionPersons = sessions ? Math.max(...sessions.map(session => session.available_places)) : 0;
    const currentSessionPlaces = sessions.find(({ id }) => id === session_id);

    this.props.actions.reservation.changePersons(+e.target.value);
    this.props.actions.reservation.changeLanguage(this.state.checkedLanguages);

    if (isMobile) {
      scrollIntoView(document.querySelector('.reservation-dialog__col_date'));
    }

    if ((sessions && +e.target.value > maxSessionPersons) ||
     (currentSessionPlaces && +e.target.value > currentSessionPlaces.available_places && currentSessionPlaces.available_places < maxSessionPersons)) {
      this.setState({
        selectedDate: null,
      });
      this.props.actions.reservation.changeDate(null);
      this.props.actions.reservation.changeLanguage(this.state.checkedLanguages);
    }

    this.placesFromUrlFilters = 0;

    return false;
  }

  handleDayClick(form) {
    return (day, { available }) => {
      if (available) {
        const date = dateFormat(day, 'isoDate');
        const formDate = form.getState().values.date;

        if (formDate !== date) {
          this.props.actions.reservation.changeDate(date);
          form.change('date', date);
        }
        this.setState({
          selectedDate: day,
        }, () => {
          if (isMobile) {
            scrollIntoView(document.querySelector('.reservation-dialog__col_time'));
          }
        });
      }
    };
  }

  handleSessionClick(e) {
    this.props.actions.reservation.changeSession(e.target.value);
  }

  handleLanguageClick(languages) {
    const { dialog: { sessions, session_id } } = this.props;

    const filteredSessions = sessions.filter(session => languages.includes(session.language));
    const displayOnFilterSessions = !languages.length ? sessions : filteredSessions;
    const isSelectedSession = displayOnFilterSessions.find(({ id }) => id === session_id);

    this.setState({
      checkedLanguages: languages
    });

    if (languages && languages.length === 0) {
      this.setState({
        selectedDate: null,
      });
    }

    if (!isSelectedSession && languages && languages.length !== 0) {
      this.setState({
        selectedDate: null,
      });
      this.props.actions.reservation.changeDate(null);
    }
    this.props.actions.reservation.changeLanguage(languages);
  }

  get persons() {
    const {
      sessions,
      dialog: {
        sessions: availableSessions,
      },
      staffUser,
    } = this.props;

    const maxPersons = Math.max(...sessions.map(o => o.available_places));
    if (maxPersons === -Infinity) return null;

    let maxAvailablePersons = maxPersons;
    if (availableSessions.length > 0) {
      maxAvailablePersons = Math.max(...availableSessions.map(o => o.available_places));
    }

    return (
      <Field
        type="select"
        name="persons"
        onChange={this.handlePersonsChange}
        disabled={staffUser}
      >
        {new Array(maxPersons).fill(1).map((_, i) => (
          <option
            key={Math.random()}
            value={i + 1}
            className={i + 1 > maxAvailablePersons ? 'unusable' : ''}
          >
            {`${i + 1} ${t('Pers.', DT_RESERVATION)}`}
          </option>
        ))}
      </Field>
    );
  }

  static validate({ persons, date, session }) {
    const errors = {};
    const required = 'Required';
    if (!persons) {
      errors.persons = required;
    }
    if (!date) {
      errors.date = required;
    }
    if (!session) {
      errors.session = required;
    }
    return errors;
  }

  close(e) {
    e.preventDefault();
    this.setState({
      selectedDate: null,
    }, () => {
      this.props.actions.modal.hide('reservation.dialog');
    });
    return false;
  }

  onSubmit({ persons, session }, form) {
    const cursusToChange = storage.get(`cart.dialog.cursus`);
    let cursusSessions = [];
    for (const prop in cursusToChange) {
      cursusSessions = cursusSessions.concat(cursusToChange[prop].data.sessions);
    }
    if (cursusSessions.includes(session)) {
      this.showMessage(t("This session has already been added to your basket. Please select another session.", DT_CURSUS), 'type-error');
      return false;
    }

    if (this.props.staffUser && session in this.props.cart.dialog.sessions) {
      this.setState({
        reservationSuccess: false,
      });
    } else {
      this.setState({
        reservationSuccess: true,
      });
    }

    this.setState({
      openModalMessage: true,
    });

    if (persons && session) {
      this.props.actions.cart.addToCart(persons, session);
      setTimeout(() => {form.reset({persons: 1,});}, 0);

      this.setState({
        selectedDate: null,
      });
      this.props.actions.modal.hide('reservation.dialog');

      const selectedItem = this.props.sessions.filter(sessionObj => session.includes(sessionObj.id));
      const item_list_name = this.props.global.item_list_name;
      window.dataLayer && dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: this.props.currency_code,
          items: [{
            item_name: this.props.original_title,
            item_id: this.props.id,
            price: selectedItem[0].price + selectedItem[0].tax,
            item_category: this.props.category,
            item_type: this.props.productType,
            quantity: 1,
            course_participants: persons,
            course_language: selectedItem[0].original_language,
            course_date: selectedItem[0].original_date,
            course_time: selectedItem[0].time,
            item_list_name: item_list_name || 'N/A',
            item_list_id: pg_type + ' - ' + (item_list_name || 'N/A') + ' - ' + window.location.pathname,
          }]
        }
      });
    }
  }

  get monthsRange() {
    const {
      dialog: { sessions },
    } = this.props;

    if (!sessions.length) {
      return {
        max: null,
        min: null
      };
    }

    const min = Math.min
      .apply(null, sessions.map(({ date }) => new Date(date).getTime()));
    const max = Math.max
      .apply(null, sessions.map(({ date }) => new Date(date).getTime()));
    const TIMEZONE = new Date().getTimezoneOffset();

    return {
      min: new Date(TIMEZONE > 0 ? min + TIMEZONE * 60000 : min),
      max: new Date(TIMEZONE > 0 ? max + TIMEZONE * 60000 : max),
    };
  }

  convertTimezone(time, full = false) {
    let d = new Date(time);
    const TIMEZONE = d.getTimezoneOffset();
    if (TIMEZONE > 0) {
      d.setTime(d.valueOf() + TIMEZONE * 60000);
    }
    return full ? d : dateFormat(d, 'isoDate');
  }

  static getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  render() {
    const {
      title, color,
      total_places,
      languages,
      isOpen,
      dialog: {
        persons = 1, date, session_id, sessions: filteredSessions, time: sessionTime
      },
      modal,
    } = this.props;
    const { selectedDate, checkedLanguages } = this.state;
    const { monthsRange } = this;
    const sessionTimes = filteredSessions.filter(item => item.date === this.convertTimezone(selectedDate, false));
    const sessionsForDatepicker = checkedLanguages.length !== 0 ? filteredSessions : [];

    return (
      <div ref={this.productWrapperRef}>
        {!isOpen && (
          <Message
            isOpen={this.state.openModalMessage}
            type={this.state.reservationSuccess ? 'success' : 'error'}
            messageText={this.state.reservationSuccess ? t('Session was added to your selection', DT_RESERVATION) : t('You cannot add twice the same session in your shopping bag', DT_RESERVATION)}  />
        )}
        {(({ isOpen, message, hideButton, type = 'type-error' }) => isOpen && (
          <div className={'gift-modal-dialog__error-message ' + type}>
            <span dangerouslySetInnerHTML={{ __html: message }} />
            <a
              href="#"
              onClick={this.hideError}
              style={{
                display: hideButton ? 'none' : 'inline-block',
              }}
              className="gift-modal-dialog__error-message-close"
            >
              <Icon name="close" />
            </a>
          </div>
        ))(modal['reservation.error'])}
        <Portal
          id="reservation.dialog"
          className="reservation-dialog__portal"
          onClose={this.close}
          isOpen
        >
          <div className="reservation-dialog">
            <header
              className="reservation-dialog__header"
              style={{
                backgroundColor: color,
              }}
            >
              <div className="container">
                <span className="reservation-dialog__title">
                  { title }
                </span>

                <div className="reservation-dialog__close">
                  <button onClick={this.close} />
                </div>
              </div>
            </header>

            <Form
              onSubmit={this.onSubmit}
              initialValues={{
                persons: this.placesFromUrlFilters && this.placesFromUrlFilters !== 0 ? this.placesFromUrlFilters : persons,
                date,
                session: session_id,
              }}
              validate={Reservation.validate}
            >
              {({ handleSubmit, form, invalid }) => (
                <form
                  onSubmit={handleSubmit}
                >
                  <section className="reservation-dialog__body">
                    <div className="container">

                      <div className="reservation-dialog__col reservation-dialog__col_language">
                        <div className="reservation-dialog__col-title">
                          {t('Languages', DT_SESSIONS)}
                        </div>
                        <div className="reservation-dialog__col-body">
                          {languages.length && (<Languages
                            list={languages}
                            checked={checkedLanguages}
                            form={form}
                            actions={this.props.actions}
                            onAddCategory={this.handleLanguageClick}
                          />)}
                        </div>
                      </div>

                      <div className="reservation-dialog__col">
                        <div className="reservation-dialog__col-title">
                          {total_places ? (
                            <span>
                              {total_places === 1 ? (
                                <span>{t('Select the number of participants up to', DT_RESERVATION).total_places_val_1(total_places)}</span>
                              ) : (
                                <span>{t('Select the number of participants up to', DT_RESERVATION).total_places_val(total_places)}</span>
                                )}
                            </span>
                          ) : (
                            <span>
                              {t('Select the number of participants', DT_RESERVATION)}
                            </span>
                          )}
                        </div>
                        <div className="reservation-dialog__col-body">
                          { this.persons }
                        </div>
                      </div>

                      <div className="reservation-dialog__col reservation-dialog__col_date">
                        <div className="reservation-dialog__col-title">
                          {t('Select the date', DT_RESERVATION)}
                        </div>
                        <div className="reservation-dialog__col-body">
                          <Daypicker
                            className="Available"
                            fromMonth={monthsRange.min}
                            toMonth={monthsRange.max}
                            month={date ? this.convertTimezone(date, true) : monthsRange.min}
                            modifiers={{
                              available: sessionsForDatepicker
                                  .map((s) => {
                                    if (s.available_places >= persons) {
                                      return this.convertTimezone(s.date, true);
                                    }
                                  })
                            }}
                            selectedDays={ this.convertTimezone(selectedDate, true)}
                            onDayClick={this.handleDayClick(form)}
                          />
                        </div>
                      </div>

                      <div className="reservation-dialog__col reservation-dialog__col_time">
                        <div className="reservation-dialog__col-title">
                          {t('Select the time', DT_RESERVATION)}
                        </div>

                        {this.state.selectedDate && (
                          <div className="reservation-dialog__col-body sessions">
                            {sessionTimes.map(({ id, time, available_places, course_language }, index) => {
                              let defaultTimeHere = false;
                              if (sessionTime) {
                                sessionTimes.map(({time}) => {
                                  if (sessionTime == time) {
                                    defaultTimeHere = true;
                                  }
                                });
                              }
                              return (
                                <Field
                                  key={id}
                                  name="session"
                                  value={id}
                                  type="radio"
                                  defaultChecked={
                                    sessionTime &&
                                    defaultTimeHere ?
                                      sessionTime == time && id == session_id :
                                      sessionTimes[0].id == id
                                  }
                                  label={(
                                    <div>
                                    <span>
                                      { time }
                                    </span>
                                    <span className="sessions__language">{course_language}</span>
                                    </div>
                                  )}
                                  onChange={(e) => { this.handleSessionClick(e) }}
                                  disabled={persons > available_places}
                                />
                            )})}
                          </div>
                        )}
                      </div>
                    </div>
                  </section>

                  <footer className="reservation-dialog__footer">
                    <button
                      type="submit"
                      className="button"
                      disabled={invalid || checkedLanguages.length === 0 || !selectedDate}
                    >
                      <Icon name="checked" />
                      <span>
                        {t('Book now', DT_RESERVATION)}
                      </span>
                    </button>
                  </footer>
                </form>
              )}
            </Form>
          </div>
        </Portal>
      </div>
    );
  }
}

export default connect(
  state => ({
    isOpen: state.modal['reservation.dialog'].isOpen,
    cart: state.cart,
    modal: state.modal,
    global: state.global,
    ...state.reservation,
  }),
  dispatch => ({
    actions: {
      modal: bindActionCreators(modal, dispatch),
      reservation: bindActionCreators(reservation, dispatch),
      cart: bindActionCreators(cart, dispatch),
      global: bindActionCreators(global, dispatch),
    },
  }),
)(Reservation);
